import { RiSearchLine, RiCloseLine } from '@remixicon/react'
import styles from './integrations.module.css'

export function Search({
  value,
  onChange
}: {
  value: string
  onChange: (value: string) => void
}): JSX.Element {
  return (
    <form
      className={styles.search}
      role="search"
      aria-label="Integration search"
      onSubmit={event => event.preventDefault()}
    >
      <RiSearchLine aria-hidden="true" />
      <label htmlFor="integration-search" className="sr-only">
        Search integrations
      </label>
      <input
        id="integration-search"
        type="search"
        value={value}
        onChange={event => onChange(event.target.value)}
        placeholder="Find an app, like Slack or Google Sheets"
      />
      {value && (
        <button
          type="button"
          aria-label="Clear integration search"
          onClick={() => onChange('')}
        >
          <RiCloseLine aria-hidden="true" />
        </button>
      )}
    </form>
  )
}
